export const PrecheckType = {
  DomainMatch: 'domain_match'
} as const

export type PrecheckType = typeof PrecheckType[keyof typeof PrecheckType]

export const PrecheckStatus = {
  // Precheck matched — e.g. email domain matches the organisation.
  Success: 'success',
  // Ran, but no match (a free/common email domain such as gmail always fails).
  Failure: 'failure',
  // Couldn't run: type not enabled on the config, or organisation not found.
  Error: 'error'
} as const

export type PrecheckStatus = typeof PrecheckStatus[keyof typeof PrecheckStatus]

export type RequestedPrecheck = {
  type: PrecheckType
  email: string
  organisationId: string
}

export type RunHostedFormPrechecksProps = {
  validationInviteId: string
  prechecks: RequestedPrecheck[]
}

export type HostedFormPrecheckResult = {
  type: PrecheckType
  status: PrecheckStatus
  message?: string
}

export type HostedFormPrecheckResponse = {
  data: {
    results: HostedFormPrecheckResult[]
  }
}
